export const OptionsForm = {
  "Modal": {
    "Title": "Options"
  },
  "Label": {
    "AlwaysAddMsg": "Always add bookmarks",
    "AddPageMsg": "Add a new table of contents page converted from bookmarks",
    "ContinueCombineMsg": "Continue combining if an error occurs",
    "RetainPageNumberMsg": "Retain the logic page number during combination"
  },
  "Button": {
    "OK": "OK",
    "Cancel": "Cancel"
  }
}